/**
 * Shared enum lists for the rooms editor + buyer-side room table.
 *
 * Order matches the design spec §1.2 (display order) — Primary/Living-style
 * common rooms first, then bedrooms / utility, ending with Other. The order
 * is purely a UX nicety; the backend stores the enum string verbatim.
 *
 * Kept in sync with `backend/app/models/room.py` ROOM_TYPES / ROOM_LEVELS /
 * ROOM_FLOORINGS tuples.
 */

export const ROOM_TYPES = [
  'PrimaryBedroom',
  'Bedroom',
  'Kitchen',
  'LivingRoom',
  'DiningRoom',
  'FamilyRoom',
  'Den',
  'Office',
  'Bathroom',
  'Laundry',
  'Foyer',
  'Other',
];

// Top-to-bottom reading order — feels familiar when reading a floor plan.
export const ROOM_LEVELS = ['Main', 'Upper', 'Lower', 'Basement', 'Loft'];

export const ROOM_FLOORINGS = [
  'Hardwood',
  'Tile',
  'Carpet',
  'Laminate',
  'Vinyl',
  'Concrete',
  'Other',
];

export const ROOMS_MAX = 20;

/**
 * Default sort order for the buyer-side room table: level (Main first),
 * then a soft pin of common social rooms within each level.
 */
export const LEVEL_ORDER_INDEX = ROOM_LEVELS.reduce((m, l, i) => {
  m[l] = i;
  return m;
}, {});

export const TYPE_PIN_ORDER = {
  PrimaryBedroom: 0,
  LivingRoom: 1,
  Kitchen: 2,
  DiningRoom: 3,
  FamilyRoom: 4,
};

/**
 * Returns a human-readable label for a room_type enum value.
 * "PrimaryBedroom" → "Primary Bedroom"
 */
export function roomTypeLabel(value) {
  if (!value) return '';
  return String(value).replace(/([a-z])([A-Z])/g, '$1 $2');
}
